var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-press-escape": false,
        "custom-class": "layout-dialog",
        title: "不具合履歴",
        top: "5vh",
        visible: _vm.dialogVisible,
        "append-to-body": "",
        width: "70%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: function ($event) {
          _vm.dialogVisible = false
        },
      },
    },
    [
      _c("vab-table", {
        ref: "table",
        attrs: {
          columns: _vm.columns,
          "has-pager": false,
          "custom-config": false,
          "table-data": _vm.tableDataList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }